"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mergeWith2 = _interopRequireDefault(require("lodash/mergeWith"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _set2 = _interopRequireDefault(require("lodash/set"));
var _first2 = _interopRequireDefault(require("lodash/first"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _kebabCase2 = _interopRequireDefault(require("lodash/kebabCase"));
var _isString2 = _interopRequireDefault(require("lodash/isString"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _last2 = _interopRequireDefault(require("lodash/last"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _EXTENSION_PREFIX_BY_;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CONTEXT = 'context';
var RESULT = 'result';
var EXTENSIONS_PREFIX = 'https://api.amplify.com/xapi/extensions/';
var EXTENSION_PREFIX_BY_TYPE = (_EXTENSION_PREFIX_BY_ = {}, _defineProperty(_EXTENSION_PREFIX_BY_, CONTEXT, EXTENSIONS_PREFIX + 'contexts/'), _defineProperty(_EXTENSION_PREFIX_BY_, RESULT, EXTENSIONS_PREFIX + 'results/'), _EXTENSION_PREFIX_BY_);

// At each level, skip formatting of properties
// with the keys listed.
var FORMATTING_ALLOW_LIST = {
  keys: ['timestamp'],
  actor: {
    keys: ['account']
  },
  verb: {
    keys: ['display']
  },
  object: {
    keys: ['objectType'],
    definition: {
      keys: []
    }
  },
  context: {
    keys: ['revision', 'language'],
    extensions: {
      keys: [EXTENSION_PREFIX_BY_TYPE[CONTEXT] + 'library-version', EXTENSION_PREFIX_BY_TYPE[CONTEXT] + 'environment', EXTENSION_PREFIX_BY_TYPE[CONTEXT] + 'search-phrase']
    }
  },
  result: {
    extensions: {
      keys: []
    }
  }
};
var Formatter = /*#__PURE__*/function () {
  function Formatter() {
    _classCallCheck(this, Formatter);
    this.formattingAllowList = FORMATTING_ALLOW_LIST;
  }

  /**
   * Format an xAPI statement.
   *
   * @param {Object} statement
   * @return {Object} The formatted statement
   */
  _createClass(Formatter, [{
    key: "formatStatement",
    value: function formatStatement(statement) {
      return this._formatObject(statement);
    }

    /**
     * Configure allowList of properties to be skipped when applying auto-formatting.
     * Custom allowList properties are validated and merged with defaults.
     *
     * @param {Object} customAllowList
     */
  }, {
    key: "setFormattingAllowList",
    value: function setFormattingAllowList(customAllowList) {
      this.formattingAllowList = this._mergeAllowLists(FORMATTING_ALLOW_LIST, this._validateCustomAllowList(customAllowList));
    }

    /**
     * Update the formatting allowList. The new list is validated and merged with the existing one.
     *
     * @param {Object} customAllowList
     */
  }, {
    key: "updateFormattingAllowList",
    value: function updateFormattingAllowList(customAllowList) {
      var currentAllowList = this.formattingAllowList;
      this.formattingAllowList = this._mergeAllowLists(currentAllowList, this._validateCustomAllowList(customAllowList));
    }

    /**
     * Recursively format object properties.
     *
     * @param {*} obj The entity to format at each iteration. If not an object, recursion will stop
     * @param {Array<string>?} path List of path keys relative to the parent object for the current iteration
     * @param {boolean?} skipFormatting Whether the current property is on the allowList and should skip formatting
     * @return {Object} The formatted object
     */
  }, {
    key: "_formatObject",
    value: function _formatObject(obj, path, skipFormatting) {
      var _this = this;
      if (skipFormatting) {
        return obj;
      } else if (!(0, _isObject2["default"])(obj)) {
        var parentKey = (0, _last2["default"])(path);
        return this._formatValue(obj, parentKey);
      } else {
        return Object.entries(obj).reduce(function (formattedObj, _ref) {
          var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];
          var skipFormattingForChild = _this._isKeyInAllowList(key, path);
          var childPath = path ? path.concat([key]) : [key];
          var formattedKey = skipFormattingForChild ? key : _this._formatValue(key);
          var formattedValue;
          if ((0, _isArray2["default"])(value)) {
            formattedValue = _this._formatArray(value, key, skipFormattingForChild);
          } else {
            formattedValue = _this._formatObject(value, childPath, skipFormattingForChild);
          }
          formattedObj[formattedKey] = formattedValue;
          return formattedObj;
        }, {});
      }
    }

    /**
     * Format array into object with formatted values.
     *
     * @param {Array<*>} array The array to format
     * @param {string} key Name of the property that holds the array in the entity
     * @param {boolean?} skipFormatting Whether the current property is on the allowList and should skip formatting
     * @return {Object}
     */
  }, {
    key: "_formatArray",
    value: function _formatArray(array, key, skipFormatting) {
      var _this2 = this;
      if (skipFormatting) {
        return array;
      } else {
        return array.reduce(function (formattedVal, current, index) {
          formattedVal[index] = _this2._formatValue(current, key);
          return formattedVal;
        }, {});
      }
    }

    /**
     * Format an object property; choose formatting method based on whether the value is an IRI.
     * Return without formatting if the argument is not a string or if the value represents a business key.
     *
     * @param {*} value The value being formatted
     * @param {string?} key The key for the value being formatted, if there is one
     * @return {*} The formatted string, else the original value if formatting was skipped
     */
  }, {
    key: "_formatValue",
    value: function _formatValue(value, key) {
      if (!(0, _isString2["default"])(value) || this._isBusinessKey(key)) return value;
      return this._isIRI(value) ? this._formatIRI(value) : this._formatString(value);
    }

    /**
     * Format a string. Converts strings to kebab-case unless they are UUIDs or URLs.
     *
     * @param {string} str
     * @return {string} The formatted string
     */
  }, {
    key: "_formatString",
    value: function _formatString(str) {
      return !this._isUUID(str) && !this._isURL(str) ? (0, _kebabCase2["default"])(str) : str;
    }

    /**
     * Format an IRI. Applies string formatting to the final part of the path.
     *
     * @param {string} iri
     * @return {string} The formatted IRI
     */
  }, {
    key: "_formatIRI",
    value: function _formatIRI(iri) {
      var iriParts = iri.split('/');
      iriParts[iriParts.length - 1] = this._formatString(iriParts[iriParts.length - 1]);
      return iriParts.join('/');
    }

    /**
     * Determine whether a key is in the formatting allowList based on its path within its parent object.
     *
     * @param {string} key
     * @param {Array<string>?} path
     * @return {boolean}
     */
  }, {
    key: "_isKeyInAllowList",
    value: function _isKeyInAllowList(key, path) {
      var keysPath = path ? path.concat(['keys']) : ['keys'];
      var allowedKeys = (0, _get2["default"])(this.formattingAllowList, keysPath, []);
      return allowedKeys.includes(key);
    }

    /**
     * Return true if the string represents an IRI.
     *
     * @param {string} str
     * @return {boolean}
     */
  }, {
    key: "_isIRI",
    value: function _isIRI(str) {
      return !(0, _isNil2["default"])(str.match(new RegExp('^(https://api.amplify.com)')));
    }

    /**
     * Return true if string is a URL.
     *
     * @param {string} str
     * @return {boolean}
     */
  }, {
    key: "_isURL",
    value: function _isURL(str) {
      return !(0, _isNil2["default"])(str.match(/^http|^www/));
    }

    /**
     * Return true if string is of UUID format.
     *
     * @param {string} str
     * @return {boolean}
     */
  }, {
    key: "_isUUID",
    value: function _isUUID(str) {
      return !(0, _isNil2["default"])(str.match(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/i));
    }

    /**
     * Return true if a property key indicates that its value represents a business key.
     * We will skip formatting of these values.
     * The current logic for this is to check whether the key includes the substring 'key'.
     *
     * @param {string} key
     * @return {boolean}
     */
  }, {
    key: "_isBusinessKey",
    value: function _isBusinessKey(key) {
      if (!key) {
        return false;
      } else {
        key = this._isIRI(key) ? (0, _last2["default"])(key.split('/')) : key;
        return (0, _kebabCase2["default"])(key).split('-').some(function (partOfKeyName) {
          return partOfKeyName === 'key' || partOfKeyName === 'keys';
        });
      }
    }

    /**
     * Recursively validate custom formatting allowList object; remove any invalid properties and warn.
     *
     * @param {Object} obj Object to validate
     * @param {Array<string>?} path The object path
     * @return {Object}
     */
  }, {
    key: "_validateCustomAllowList",
    value: function _validateCustomAllowList(obj) {
      var _this3 = this;
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      return Object.entries(obj).reduce(function (validatedObj, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          key = _ref4[0],
          value = _ref4[1];
        var childPath = path.concat([key]);
        var pathStr = childPath.join('.');
        if (key === 'keys') {
          if ((0, _isArray2["default"])(value)) {
            var validKeys = value.filter(function (val) {
              return (0, _isString2["default"])(val);
            });
            if (validKeys.length !== value.length) {
              console.warn("allowList keys must be an array of strings; ignoring non-string keys at ".concat(pathStr));
            }

            // If these are context or result extensions, make sure they are prefixed.
            if ((0, _last2["default"])(path) === 'extensions') {
              var extensionsType = (0, _first2["default"])(path);
              validKeys = validKeys.map(function (key) {
                if (!key.includes(EXTENSIONS_PREFIX) && EXTENSION_PREFIX_BY_TYPE[extensionsType]) {
                  return EXTENSION_PREFIX_BY_TYPE[extensionsType] + key;
                }
                return key;
              });
            }
            (0, _set2["default"])(validatedObj, childPath, validKeys);
          } else {
            console.warn("allowList keys must be an array of strings; invalid keys at ".concat(pathStr));
          }
        } else if ((0, _isObject2["default"])(value)) {
          if (!(0, _has2["default"])(FORMATTING_ALLOW_LIST, childPath)) {
            console.warn("Unsupported allowList property ".concat(pathStr));
          } else {
            var validatedNestedObj = _this3._validateCustomAllowList(value, childPath);
            (0, _set2["default"])(validatedObj, childPath, (0, _get2["default"])(validatedNestedObj, childPath));
          }
        } else {
          console.warn("Unrecognized allowList value at ".concat(pathStr));
        }
        return validatedObj;
      }, {});
    }

    /**
     * Merge two formatting allowLists and return.
     *
     * @param {Object} firstAllowList
     * @param {Object} secondAllowList
     * @return {Object}
     */
  }, {
    key: "_mergeAllowLists",
    value: function _mergeAllowLists(firstAllowList, secondAllowList) {
      return (0, _mergeWith2["default"])(firstAllowList, secondAllowList, function (objValue, srcValue) {
        if ((0, _isArray2["default"])(objValue)) {
          return objValue.concat(srcValue);
        }
      });
    }
  }]);
  return Formatter;
}();
var _default = new Formatter();
exports["default"] = _default;
module.exports = exports.default;